/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentGetQueryResponse, ContentGetPathParams } from "../models/ContentGet";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { contentGet } from "../axios/contentGet";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const contentGetQueryKey = (id: ContentGetPathParams["id"]) => ["content-ai-api", { url: '/contents/:id', params: {id:id} }] as const

export type ContentGetQueryKey = ReturnType<typeof contentGetQueryKey>

export function contentGetQueryOptions(id: ContentGetPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = contentGetQueryKey(id)
  return queryOptions<ContentGetQueryResponse, ResponseErrorConfig<Error>, ContentGetQueryResponse, typeof queryKey>({
   enabled: !!(id),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return contentGet(id, config)
   },
  })
}

/**
 * @summary Get content by ID
 * {@link /contents/:id}
 */
export function useContentGet<TData = ContentGetQueryResponse, TQueryData = ContentGetQueryResponse, TQueryKey extends QueryKey = ContentGetQueryKey>(id: ContentGetPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<ContentGetQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? contentGetQueryKey(id)

  const query = useQuery({
   ...contentGetQueryOptions(id, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}